import { FC, useRef, useState } from 'react';
import { useScroll } from '@use-gesture/react';
import { FilterOption } from './Filters.types';
import { FiltersOption } from './FiltersOption';
import classNames from 'classnames';

export interface FiltersOptionsGroupProps {
  name: string;
  label?: string;
  options: FilterOption[];
}

export const FiltersOptionsGroup: FC<FiltersOptionsGroupProps> = ({ label, options }) => {
  const ref = useRef(null);
  const [scrollPosition, setScrollPosition] = useState({ x: 0, y: 0 });

  useScroll(({ xy: [x, y] }) => setScrollPosition({ x, y }), { target: ref });

  return (
    <div
      className={classNames(`filters__options-group mt-2 mb-2`, {
        [`scroll-x-start`]: scrollPosition.x === 0,
        [`scroll-x-center`]:
          scrollPosition.x > 0 && scrollPosition.x < ref?.current?.scrollWidth - ref?.current?.clientWidth,
        [`scroll-x-end`]: scrollPosition.x === ref?.current?.scrollWidth - ref?.current?.clientWidth
      })}
    >
      {label && <h3 className="filters__options-group__label">{label}</h3>}
      <ul ref={ref} className={classNames(`filters__options overflow-x-auto flex flex-row flex-nowrap gap-2 p-0`)}>
        {options.map(option => (
          <FiltersOption key={`${option.name} ${option.value}`} {...option} />
        ))}
      </ul>
    </div>
  );
};
